<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<empty v-if="emptyState"></empty>
			<div v-else>
				<ul class="message-list">
					<li v-for="(item, i) in dataList" :key="i" class="flex-between-center" :class="{'z-new': item.state == 1}" @click="clickHandle(item)">
						<p>{{item.title}}</p>
						<span>{{item.create_date}}</span>
					</li>
				</ul>
			
				<pagination ref="pagination" :total="total" @handle="updateList"></pagination>
			</div>
		</menu-aside>
		
		<c-dialog ref="detail" title="消息通知详情" width="850" height="670" :button="false">
			<h1 class="message-title">{{messageContent.title}}</h1>
			<div v-html="messageContent.content" class="message-content"></div>
		</c-dialog>
	</app>
</template>

<script>
	import empty from '@/components/public/empty.vue'
	import pagination from '@/components/public/pagination'
	
	export default {
		components: {
			empty,
			pagination
		},
		
		data() {
			return {
				dataList: [],
				total: 1,
				emptyState: false,
				messageContent: {}
			}
		},
		
		mounted() {
			this.$refs.pagination.update(1);
		},
		
		methods: {
			updateList(page) {
				this.request({
					url: '/sysnotice/list',
					data: page,
					success: data => {
						this.dataList = data;
						this.emptyState = !data.length && page.pageIndex == 1;
					},
					response: res => {
						this.total = res.total;
					}
				});
			},
			
			clickHandle(item) {
				this.messageContent = item;
				this.$refs.detail.open();
				
				this.request({
					url: '/sysnotice/read',
					data: {
						sn_id: item.id
					},
					success: () => {
						item.state = 2;
					}
				});
			
				this.$store.dispatch('updateMessageTotal', false);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.message {
		&-list {
			li {
				height: 56px;
				border-bottom: 1px solid #eee;
				cursor: pointer;
				
				elder({
					height: 80px
				})
				
				&.z-new {
					p {
						position: relative;
						color: #000;
						
						&:after {
							content: '';
							position: absolute;
							right: -10px;
							top: 2px;
							width: 5px;
							height: 5px;
							border-radius: 100%;
							background: #f00;
						}
					}
				}
				
				&:hover {
					p {
						color: #4497F7;
					}
				}
				
				p {
					font-size: 16px;
					color: #666;
					
					elder({
						font-size: 26px
					})
				}
				
				span {
					font-size: 14px;
					color: #999;
					
					elder({
						font-size: 24px
					})
				}
			}
		}
		
		&-title {
			padding: 20px 32px;
			line-height: 28px;
			font-size: 20px;
			text-align: center;
			color: #000;
			background: #F6F7F8;
			
			elder({
				line-height: 48px,
				font-size: 30px
			})
		}
		
		&-content {
			padding: 32px;
			line-height: 22px;
			font-size: 14px;
			
			elder({
				line-height: 36px,
				font-size: 24px
			})
		}
	}
</style>
